import { render, staticRenderFns } from "./SwitchControl.vue?vue&type=template&id=4a39b9a6"
import script from "./SwitchControl.vue?vue&type=script&lang=js"
export * from "./SwitchControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports